import { DefaultCarPageComponentProps } from "@/app/interface/components";
import { getVehicleTech } from "@/app/utils/vehiclesInfo";
import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
export default function TechSpecsMobile({
  car,
  model,
  version,
}: DefaultCarPageComponentProps) {
  const info = getVehicleTech(
    car?.name ? car.name.toLowerCase().replaceAll(" ", "-") : "",
    model?.name || "",
    version?.name || ""
  );

  const [active, setActive] = useState(false);
  const specs = [
    {
      label: "MOTOR",
      value: info?.motor,
    },
    {
      label: "TIPO DE COMBUSTÍVEL",
      value: info?.tipoDeCombustivel,
    },
    {
      label: "CAPACIDADE DE CARGA",
      value: info?.capacidadeDeCarga,
    },
    {
      label: "DESEMPENHO",
      value: info?.desempenho,
    },
    {
      label: "TRANSMISSÃO",
      value: info?.transmissao,
    },
    {
      label: "ÁUDIO MULTIMÍDIA",
      value: info?.audioMultimidia,
    },
  ];

  const getColors = (modelCar?: string) => {
    switch (modelCar) {
      case "Híbrido":
        return {
          bg: "#0D2370",
          filter: "hibridColor",
        };
      case "Esportivo":
        return {
          bg: "#C00611",
          filter: "sportiveColor",
        };
      case "hatch":
        return {
          bg: "#1A1A1A",
          filter: "defaultColor",
        };
      case "Plug-in":
        return {
          bg: "#0D2370",
          filter: "otherColor",
        };
      default:
        return {
          bg: "#1A1A1A",
          filter: "defaultColor",
        };
    }
  };
  return (
    <>
      <div className="flex w-full">
        {/* <Image
          width={400}
          height={400}
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/d9c55928c4a3169f12deadf74c1040ae9f9a0bfd0bf34b190165773621e04262?placeholderIfAbsent=true&apiKey=eac21aa640a54d679c8b4aff1d0cf286"
          alt="wave"
          className={`${
            getColors(model?.name)?.filter
          } w-full relative z-0 -mb-1"`}
        /> */}
        <div className="w-full" />
      </div>
      <div
        className="flex flex-col w-full  p-8"
        style={{
          backgroundColor: getColors(model?.name)?.bg,
        }}
      >
        <div className="flex w-full items-center justify-between">
          <h2 className="text-white text-2xl">Ficha técnica</h2>
          <AiOutlinePlus
            size={26}
            className={
              `text-white cursor-pointer transition-all ` +
              (active ? "rotate-[135deg]" : "rotate-0")
            }
            onClick={() => setActive(!active)}
          />
        </div>
        <div
          className={`flex flex-col gap-4 items-center justify-center transition-all duration-700 mt-5 w-full overflow-hidden h-fit ${
            active ? "max-h-full" : "max-h-0"
          }`}
        >
          {specs.map((spec, index) => (
            <div
              key={spec.label + index}
              className="flex flex-col gap-2 mt-2 items-start justify-start text-left w-full pb-5"
            >
              <div className="flex items-center w-full">
                <span className="flex shrink-0 h-[12px] rounded-full border-2 -mt-1 border-white w-[12px]" />
                <hr className="flex-1 shrink self-stretch h-px border border-white w-[243px]" />
              </div>
              <h3 className="mt-2 text-lg font-semibold text-white">
                {spec.label}
              </h3>
              <p className="mt-2 text-base leading-snug text-stone-50">
                {spec.value || "Informação não disponível"}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
